import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {catchError, map, switchMap} from "rxjs/operators";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class SerpApiService {

  private apiUrl = environment.api.url;

  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) { }

  updateSerpApi(user_id: number, location: string, domain: string, language: string): Observable<{ data: any }> {
    const url = `${this.apiUrl}/users/serp_api/update_profile`;
    const requestBody = { user_id, location, domain, language };

    return this.authService.token().pipe(
      switchMap(token => {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          })
        };

        return this.http.post<{ data: any, metadata: { message: string } }>(
          url,
          requestBody,
          { ...httpOptions, observe: 'response' }
        );
      }),
      map(response => {
        if (response.status === 200 && response.body && response.body.data) {
          return response.body.data;
        } else {
          throw new Error(`SerpApi update failed: ${response.body && response.body.metadata ? response.body.metadata.message : 'No data received'}`);
        }
      }),
      catchError(error => {
        console.error('SerpApi update request failed:', error);
        throw error;
      })
    );
  }

  getLocations(location: string): Observable<any[]> {
    const url = `${this.apiUrl}/serp_api/locations`;
    const requestBody = { location };

    return this.authService.token().pipe(
      switchMap(token => {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          })
        };

        return this.http.post<{ data: any[] }>(url, requestBody, httpOptions).pipe(
          map(response => {
            if (response && response.data) {
              return response.data;
            } else {
              throw new Error('No data received');
            }
          }),
          catchError(error => {
            console.error('Get locations request failed:', error);
            throw error;
          })
        );
      })
    );
  }

  getDomains(): Observable<any[]> {
    const url = `${this.apiUrl}/serp_api/domains`;

    return this.authService.token().pipe(
      switchMap(token => {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          })
        };

        return this.http.post<{ data: any[] }>(url, httpOptions).pipe(
          map(response => {
            if (response && response.data) {
              return response.data;
            } else {
              throw new Error('No data received');
            }
          }),
          catchError(error => {
            console.error('Get domains request failed:', error);
            throw error;
          })
        );
      })
    );
  }

  getLanguages(): Observable<any[]> {
    const url = `${this.apiUrl}/serp_api/languages`;

    return this.authService.token().pipe(
      switchMap(token => {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          })
        };

        return this.http.post<{ data: any[] }>(url, httpOptions).pipe(
          map(response => {
            if (response && response.data) {
              return response.data;
            } else {
              throw new Error('No data received');
            }
          }),
          catchError(error => {
            console.error('Get languages request failed:', error);
            throw error;
          })
        );
      })
    );
  }

}
